import React from 'react'
import { useHistory } from 'react-router-dom'
import { Button, FadeIn, Spinner } from 'lib/ui'
import { useCommerceHubTokens } from 'lib/modules/commercehub'
import { Item } from './components/Item'
import { Container } from './styled'

export const PaymentHome = () => {
  const history = useHistory()
  const {
    paymentTokens,
    tokensLoading,
    deleteToken,
    tokenIsDeleting
  } = useCommerceHubTokens()

  const isLoading = tokensLoading
  const isUpdating = tokenIsDeleting || tokensLoading

  return (
    <Container isUpdating={isUpdating}>
      {isLoading ? (
        <Spinner />
      ) : (
        <div className='cards'>
          {paymentTokens && !paymentTokens.length && (
            <p>No payment methods yet.</p>
          )}

          {paymentTokens?.map((paymentMethod) => {
            const publicHash = paymentMethod.publicHash
            const { maskedCc, cardholderName, expirationDate, type } = paymentMethod.details

            return (
              <Item
                key={publicHash}
                description={`${cardholderName}`}
                card={{
                  expiration: expirationDate ?? '',
                  last4: maskedCc ?? '',
                  type
                }}
                isDisabled={isUpdating}
                onDelete={() => {
                  if (window.confirm(`Delete ${type} ending in ${maskedCc}?`)) {
                    deleteToken(publicHash)
                  }
                }}
              />
            )
          })}

          <div className='new-card'>
            <FadeIn>
              <Button onClick={() => history.push('/customer/account/payment/commercehub/add')}>
                Add Payment
              </Button>
            </FadeIn>
          </div>
        </div>
      )}
    </Container>
  )
}
